import { oc } from '@orpc/contract';
import { z } from 'zod';
export const notificationRow = z.object({
    id: z.number().int(),
    kind: z.enum(['mention', 'scheduled']),
    ticketId: z.uuid(),
    ticketNumber: z.string(),
    subject: z.string().nullable(),
    storeLabel: z.string().nullable(),
    actorName: z.string().nullable(),
    preview: z.string().nullable(),
    createdAt: z.string(),
    readAt: z.string().nullable(),
});
export const notificationsListOutput = z.object({ rows: z.array(notificationRow), unread: z.number().int(), total: z.number().int() });
export const notificationsContract = {
    list: oc.route({ method: 'POST', path: '/notifications/list', summary: 'Your notifications, newest first, with the unread count' }).input(z.object({ limit: z.number().int().min(1).max(100).default(30) })).output(notificationsListOutput),
    markRead: oc.route({ method: 'POST', path: '/notifications/read', summary: 'Mark some, or all, of yours read' }).input(z.object({ ids: z.array(z.number().int()).max(200).optional() })).output(z.object({ ok: z.literal(true), marked: z.number().int() })),
};
//# sourceMappingURL=notifications.js.map